import { createSlice } from "@reduxjs/toolkit";

// The initial state of the auth slice is an object with authToken, userAccount, and permissions properties.
const initialState = {
  sessionExpired: false,
};

// The auth slice is used to maintain the authentication state of the user throughout the application.
export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionExpired: (state, action) => {
      state.sessionExpired = action.payload;
    },
  },
});

export const { setSessionExpired } = sessionSlice.actions;
